import isApiError from "@insite/client-framework/Common/isApiError";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";

import { AddWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { CustomaddWishList } from "@tSchaedlerYesco/Services/MyListBranchService";
import { CustomaddtoWishList } from "@tSchaedlerYesco/Services/MylistBranchServicesPlp";

interface Props {
    result: {
        wishList?: WishListModel;
        errorMessage?: string;
    };
}
export interface AddToWishListParameterCustom {
    productInfos: Omit<ProductInfo, "productDetailPath">[];
    selectedWishList?: WishListModel;
    newListName?: string;
    onSuccess?: (wishList: WishListModel) => void;
    onError?: (errorMessage: string) => void;
    branchName?: string;
    properties?: any;
}

type HandlerType = Handler<AddToWishListParameterCustom, Props>;

export const CustomAddWishListapi: HandlerType = async props => {
    props.result = {};
    try {
        props.result.wishList =
            props.parameter.selectedWishList ??
            (await CustomaddWishList({
                name: props.parameter.newListName,
                properties: {
                    branchName: props.parameter.properties.branchName,
                },
            }));
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

replaceInChain(chain, AddWishList, CustomAddWishListapi);
